import Typography from "component-lib/Base/components/Typography"
import { useMediaQuery, useTheme } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import getContentUrl from "utils-lib/getContentUrl"
import { wmColor } from "themes-lib/wmTheme"
import { Link } from "../../../Base"

const useStyles = makeStyles()((theme, { contentPreviewCardsList }) => ({
  contentCardWrapper: {
    paddingLeft: 19,
    position: `relative`,
    minHeight: `210px`,
    marginBottom: 35,
    [theme.breakpoints.down("xl")]: {
      paddingLeft: 0,
      marginBottom: 16,
    },
    [theme.breakpoints.down("lg")]: {
      padding: `0 9px`,
    },
    "& a": {
      color: theme.palette.primary.main,
    },
  },
  headingLink: {
    width: `76%`,
    [theme.breakpoints.down(`md`)]: {
      width: `60%`,
    },
    [theme.breakpoints.down(`sm`)]: {
      width: `100%`,
    },
    "& a": {
      marginTop: `0 !important`,
      textDecoration: `none`,
    },
  },
  contentDescription: {
    display:
      contentPreviewCardsList.contentPreviewCardsList.description.length > 200
        ? `inline`
        : `none`,
  },
  contentDate: {
    paddingBottom: `16px`,
    fontSize: 14,
    color: theme.palette.background.darkGreen,
    letterSpacing: 1.4,
    textTransform: `upperCase`,
    [theme.breakpoints.down("xl")]: {
      paddingBottom: `26px`,
    },
  },
  contentImage: {
    width: 241,
    height: 150,
    [theme.breakpoints.down("lg")]: {
      width: 200,
    },
    position: `absolute`,
    right: 0,
    top: 0,
  },
  contentCardBlock: {
    position: "relative",
    [theme.breakpoints.down(`md`)]: {
      marginBottom: 40,
      paddingBottom: 14,
    },
  },
  horizontalline: {
    width: `100%`,
    borderTop: `1px solid ${theme.palette.text.gray3}`,
    position: `absolute`,
    bottom: 0,
    right: 0,
    [theme.breakpoints.down("lg")]: {
      bottom: `unset`,
      right: `unset`,
      width: `90%`,
    },
  },
  cardText: {
    width: `68%`,
    marginTop: 12,
    color: theme.palette.text.lightHeader,
    [theme.breakpoints.down(`md`)]: {
      width: `60%`,
      marginTop: 19,
      marginBottom: 22,
    },
  },
  cardTextMobile: {
    color: theme.palette.text.lightHeader,
  },
  contentLink: {
    marginBottom: 45,
    textDecoration: `underline`,
  },
}))

const ContentPreviewList = (contentPreviewCardsList) => {
  const { classes } = useStyles({ contentPreviewCardsList })
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(`sm`))

  return (
    <div data-testid="ContentPreviewList" className="w-100">
      {!isMobile ? (
        <div className={`${classes.contentCardWrapper} w-100`}>
          <div className={`maax-font-weight-bold ${classes.contentDate} `}>
            {contentPreviewCardsList.contentPreviewCardsList.date}
          </div>

          <div className={`${classes.contentCardBlock}`}>
            <Typography
              className={`maax-font-weight-bold cardHeading ${classes.headingLink}`}
              variant="h4"
            >
              <Link
                overrideClass="maax-font-weight-black cardHeading"
                href={contentPreviewCardsList.contentPreviewCardsList.ctaLink}
                isExternalLink={
                  contentPreviewCardsList.contentPreviewCardsList.isExternalLink
                }
                style={{
                  marginTop: `0`,
                  textDecoration: `none`,
                  fontSize: `unset`,
                }}
                analytics_key={
                  contentPreviewCardsList?.contentPreviewCardsList
                    ?.analyticsKey ||
                  `${contentPreviewCardsList.contentPreviewCardsList.cardHeading} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaText} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaURL}`
                }
              >
                {contentPreviewCardsList.contentPreviewCardsList.heading}
              </Link>
            </Typography>
            <div
              className={`flex-grow-1 cardItemsubText maax-font-weight-regular ${classes.cardText}`}
              data-testid="cardDescription"
            >
              {contentPreviewCardsList.contentPreviewCardsList.description.slice(
                0,
                200,
              )}
              <span className={`${classes.contentDescription}`}>...</span>
            </div>
          </div>
          <Link
            overrideClass={`maax-font-weight-regular ${classes.contentLink}`}
            href={contentPreviewCardsList.contentPreviewCardsList.ctaLink}
            isExternalLink={
              contentPreviewCardsList.contentPreviewCardsList.isExternalLink
            }
            style={{
              bottom: `10`,
              position: `absolute`,
            }}
            analytics_key={
              contentPreviewCardsList?.contentPreviewCardsList?.analyticsKey ||
              `${contentPreviewCardsList.contentPreviewCardsList.cardHeading} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaText} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaURL}`
            }
          >
            {contentPreviewCardsList.contentPreviewCardsList.ctaLinkText}
          </Link>

          <img
            className={`${classes.contentImage}`}
            src={getContentUrl(
              contentPreviewCardsList.contentPreviewCardsList.image,
            )}
            alt={contentPreviewCardsList.contentPreviewCardsList.imageAltText}
          />
          <div className={`${classes.horizontalline}`} />
        </div>
      ) : (
        <div>
          <img
            style={{
              marginBottom: `18px`,
              width: `100%`,
              height: `245px`,
              padding: `0 9px`,
            }}
            src={getContentUrl(
              contentPreviewCardsList.contentPreviewCardsList.image,
            )}
            alt={contentPreviewCardsList.contentPreviewCardsList.imageAltText}
          />
          <div
            className={`${
              contentPreviewCardsList.contentPreviewCardsList.cardImage
                ? "WmcontentcardwithImage"
                : "WmcontentcardwithoutImage"
            }`}
            style={{ padding: `0 9px` }}
          >
            <div className="maax-font-weight-bold cardItemtitle">
              {contentPreviewCardsList.contentPreviewCardsList.date}
            </div>
            <Typography
              className={`maax-font-weight-bold cardHeading ${classes.headingLink}`}
              variant="h4"
            >
              <Link
                overrideClass="maax-font-weight-bold cardHeading"
                href={contentPreviewCardsList.contentPreviewCardsList.ctaLink}
                isExternalLink={
                  contentPreviewCardsList.contentPreviewCardsList.isExternalLink
                }
                style={{
                  marginTop: `0`,
                  textDecoration: `none`,
                  color: `${wmColor.greenHover}`,
                  fontSize: `unset`,
                  lineHeight: `unset`,
                }}
                analytics_key={
                  contentPreviewCardsList?.contentPreviewCardsList
                    ?.analyticsKey ||
                  `${contentPreviewCardsList.contentPreviewCardsList.cardHeading} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaText} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaURL}`
                }
              >
                {contentPreviewCardsList.contentPreviewCardsList.heading}
              </Link>
            </Typography>
            <div
              className={`flex-grow-1 cardItemsubText maax-font-weight-regular ${classes.cardTextMobile}`}
            >
              {contentPreviewCardsList.contentPreviewCardsList.description.slice(
                0,
                200,
              )}
              <span className={`${classes.contentDescription}`}>...</span>
            </div>
            <div
              className="contentPreviewCta"
              style={{ marginTop: `24px`, marginBottom: `44px` }}
            >
              <Link
                overrideClass="maax-font-weight-regular"
                href={contentPreviewCardsList.contentPreviewCardsList.ctaLink}
                isExternalLink={
                  contentPreviewCardsList.contentPreviewCardsList.isExternalLink
                }
                style={{
                  color: `${wmColor.greenHover}`,
                  textDecoration: `underline`,
                }}
                analytics_key={
                  contentPreviewCardsList?.contentPreviewCardsList
                    ?.analyticsKey ||
                  `${contentPreviewCardsList.contentPreviewCardsList.cardHeading} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaText} ${contentPreviewCardsList.contentPreviewCardsList.cardCtaURL}`
                }
              >
                {contentPreviewCardsList.contentPreviewCardsList.ctaLinkText}
              </Link>
            </div>
          </div>
          <div className={`${classes.horizontalline}`} />
        </div>
      )}
    </div>
  )
}

export default ContentPreviewList
